import axios from '@/plugins/axios'

export default {
  fetchYearly(params) {
    return axios.get('/currency-exchange-rates/yearly', { params: params })
      .then(response => {
        return response.data
      })
  },
  fetch(params) {
    return axios.get('/currency-exchange-rates', { params: params })
      .then(response => {
        return response.data
      })
  }
}
